









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'
import {InputOcorrenciaTrackingResponsavelSchema} from '@/schema/resource/OcorrenciaTrackingResponsavel/InputOcorrenciaTrackingResponsavelSchema'

@Component
export default class PersistOcorrenciaTrackingResponsavelView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputOcorrenciaTrackingResponsavelSchema()
  ocorrenciaTrackingResponsavel = new OcorrenciaTrackingResponsavel()

  async created() {
    await this.populate()
    if (this.ocorrenciaTrackingResponsavel.ativo == null) {
      this.ocorrenciaTrackingResponsavel.ativo = false
    }
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.ocorrenciaTrackingResponsavel.getOcorrenciaTrackingResponsavel(
        id
      )
    }

    $.await.done('getOcorrenciaTrackingResponsavel')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.ocorrenciaTrackingResponsavel.persistOcorrenciaTrackingResponsavel()
    await Helper.successAndPush(
      'system.success.persist',
      '/ocorrencia-tracking-responsavel/list'
    )
  }
}
